module.exports = __webpack_public_path__ + "img/ad-box.14cc0e33.png";